import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useFormik } from 'formik'
import { toast } from 'react-toastify'
import { Form } from 'react-bootstrap'
import Loader from '../../loader/Loader'
import Text from '../../input_filed/Text'
import SaveButton from '../../buttons/SaveButton'
import File from '../../input_filed/File'
import SingleSelect from '../../input_filed/SingleSelect'
import { PopupSchema } from './Validation'
import { AddPopupRes, AddPopupTodo } from '../../../redux/slices/popup/AddPopup'

export default function AddPopupForm(props) {
    const { bool, setBool } = props
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)

    const type_option = [
        { "value": 'vendor ', "label": "Vendor" },
        { "value": 'customer', "label": "Customer" },
        { "value": 'both', "label": "Both" },
    ]

    const initialValues = {
        name: '',
        img: "",
        type:''

    }

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: PopupSchema,

        onSubmit: (values, action) => {
            setLoading(true)
            dispatch(AddPopupTodo(bodyFormData)).then(() => add_res(action))
        }
    })

    let bodyFormData = new FormData();
    bodyFormData.append("popup_name", values.name)
    bodyFormData.append("popup_image", values.img)
    bodyFormData.append("popup_type", values.type)


    const add_res = (action) => {
        if (AddPopupRes?.success) {
            toast.success(AddPopupRes?.message, { position: "bottom-right" });
            setBool(!bool)
            setLoading(false)
            action.resetForm()
        } else {
            toast.error(AddPopupRes?.message, { position: "bottom-right" });
            setLoading(false)
        }
    }
    return (
        <>
            <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                <div className='form_layout mt-3'>
                    {loading ?
                        <div className='d-flex justify-content-center p-5'>
                            <Loader />
                        </div> :
                        <div className='row'>
                            <div className='col-md-4 '>
                                <Text
                                    label_name='Name'
                                    placeholder=''
                                    name='name'
                                    value={values.name || ''}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.name && touched.name ? (<span className='text-danger form_label' >{errors.name}</span>) : null}
                                />
                            </div>
                            <div className='col-md-4  mb-2 '>
                                <File
                                    name='img'
                                    label_name={'Image'}
                                    onBlur={handleBlur}
                                    onChange={(e) => setFieldValue("img", e.currentTarget.files[0])}
                                    error={errors.img && touched.img ? (<span className='text-danger form_label' >{errors.img}</span>) : null}
                                />
                                {/* <p></p> */}

                            </div>
                            <div className='col-md-4  mb-2'>
                                <SingleSelect
                                    closeMenu={true}
                                    label_name='Type'
                                    disabled={false}
                                    option={type_option ? type_option : []}
                                    name='type'
                                    defaultValue={''}
                                    onChange={(e) =>
                                        setFieldValue('type', e.value)
                                    }
                                    onBlur={handleBlur}
                                    error={errors.type && touched.type ? (<span className='text-danger form_label' >{errors.type}</span>) : null}
                                />
                            </div>


                            <div className='col-md-12 text-end mt-2'>
                                <SaveButton name={'Save'} />
                            </div>
                        </div>}
                </div>
            </Form>
        </>
    )
}
